import * as React from "react";

function SvgCp3(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1247.244 1247.244"
      {...props}
    >
      <defs>
        <clipPath id="cp3_svg__a" clipPathUnits="userSpaceOnUse">
          <path d="M0 6962.785h9837.817V0H0z" />
        </clipPath>
        <clipPath clipPathUnits="userSpaceOnUse" id="cp3_svg__b">
          <path d="M4390.767 3442.842c0-.375-9.505-10.002-9.505-10.002l5.664-19.623 11.828-3.585c1.949 1.782 5.013 5.444 6.548 8.463l18.718-21.803.958-1.02c-2.835-3.093-6.363-5.286-9.528-6.562l4.693-17.243 13.125-9.75.376 10.624s-5.126 47.875-5.375 48.251c-.252.375-24.334 23.749-24.334 23.749s-13.168-1.126-13.168-1.499" />
        </clipPath>
      </defs>
      <path
        d="M745.64 1053.58l-50.221-27.381c-42.157-22.986-92.363-22.7-134.256.765l-49.907 27.952c-105.496 59.088-229.724-34.67-210.218-158.659l9.228-58.653c7.745-49.236-8.056-99.339-42.254-133.981l-40.738-41.27c-86.119-87.24-39.744-240.354 78.473-259.1 81.955-12.998 152.556-67.557 188.793-145.898 52.272-113.006 205.16-113.878 258.719-1.475l25.336 53.172c21.267 44.635 62.061 75.423 109.088 82.332l56.021 8.23c118.426 17.398 166.542 169.975 81.424 258.19l-40.266 41.73c-33.8 35.031-49.028 85.311-40.723 134.457l9.896 58.544c20.919 123.757-102.232 218.925-208.396 161.045z"
        fill="#fff"
      />
      <g fontWeight={700} fontSize={40} fontFamily="Montserrat" fill="#122c2f">
        <text
          style={{
            InkscapeFontSpecification: "Montserrat-Bold",
          }}
          transform="matrix(1.0126 .86741 -.86741 1.0126 349.394 1122.042)"
        >
          <tspan y={0} x={0}>
            {"J"}
          </tspan>
        </text>
        <text
          style={{
            InkscapeFontSpecification: "Montserrat-Bold",
          }}
          transform="matrix(1.08482 .7752 -.7752 1.08482 374.703 1143.66)"
        >
          <tspan y={0} x={0}>
            {"E"}
          </tspan>
        </text>
        <text
          style={{
            InkscapeFontSpecification: "Montserrat-Bold",
          }}
          transform="scale(1.33333) rotate(27.863 -1618.933 1078.22)"
        >
          <tspan y={0} x={0}>
            {"P"}
          </tspan>
        </text>
        <text
          style={{
            InkscapeFontSpecification: "Montserrat-Bold",
          }}
          transform="matrix(1.2332 .50697 -.50697 1.2332 458.169 1194.527)"
        >
          <tspan y={0} x={0}>
            {"E"}
          </tspan>
        </text>
        <text
          style={{
            InkscapeFontSpecification: "Montserrat-Bold",
          }}
          transform="matrix(1.27802 .38007 -.38007 1.27802 496.094 1209.967)"
        >
          <tspan y={0} x={0}>
            {"U"}
          </tspan>
        </text>
        <text
          style={{
            InkscapeFontSpecification: "Montserrat-Bold",
          }}
          transform="matrix(1.31067 .24477 -.24477 1.31067 539.796 1222.649)"
        >
          <tspan y={0} x={0}>
            {"X"}
          </tspan>
        </text>
        <text
          style={{
            InkscapeFontSpecification: "Montserrat-Bold",
          }}
          transform="matrix(1.33168 .06645 -.06645 1.33168 598.97 1232.164)"
        >
          <tspan y={0} x={0}>
            {"P"}
          </tspan>
        </text>
        <text
          style={{
            InkscapeFontSpecification: "Montserrat-Bold",
          }}
          transform="matrix(1.3318 -.06382 .06382 1.3318 639.98 1234.05)"
        >
          <tspan y={0} x={0}>
            {"R"}
          </tspan>
        </text>
        <text
          style={{
            InkscapeFontSpecification: "Montserrat-Bold",
          }}
          transform="matrix(1.31748 -.205 .205 1.31748 683.682 1231.752)"
        >
          <tspan y={0} x={0}>
            {"A"}
          </tspan>
        </text>
        <text
          style={{
            InkscapeFontSpecification: "Montserrat-Bold",
          }}
          transform="matrix(1.29396 -.32162 .32162 1.29396 724.939 1225.107)"
        >
          <tspan y={0} x={0}>
            {"T"}
          </tspan>
        </text>
        <text
          style={{
            InkscapeFontSpecification: "Montserrat-Bold",
          }}
          transform="matrix(1.26873 -.41002 .41002 1.26873 760.58 1215.82)"
        >
          <tspan y={0} x={0}>
            {"I"}
          </tspan>
        </text>
        <text
          style={{
            InkscapeFontSpecification: "Montserrat-Bold",
          }}
          transform="matrix(1.23086 -.51261 .51261 1.23086 781.176 1209.531)"
        >
          <tspan y={0} x={0}>
            {"Q"}
          </tspan>
        </text>
        <text
          style={{
            InkscapeFontSpecification: "Montserrat-Bold",
          }}
          transform="matrix(1.16657 -.64567 .64567 1.16657 825.73 1190.576)"
        >
          <tspan y={0} x={0}>
            {"U"}
          </tspan>
        </text>
        <text
          style={{
            InkscapeFontSpecification: "Montserrat-Bold",
          }}
          transform="matrix(1.09512 -.76058 .76058 1.09512 865.31 1168.247)"
        >
          <tspan y={0} x={0}>
            {"E"}
          </tspan>
        </text>
        <text
          style={{
            InkscapeFontSpecification: "Montserrat-Bold",
          }}
          transform="scale(1.33333) rotate(-40.469 1501.658 -485.11)"
        >
          <tspan y={0} x={0}>
            {"R"}
          </tspan>
        </text>
      </g>
      <path
        d="M625.15 863.086l-.317 78.647"
        fill="none"
        stroke="#000"
        strokeWidth={2.66666}
      />
      <g
        clipPath="url(#cp3_svg__a)"
        transform="matrix(1.33333 0 0 -1.33333 -5181.453 7911.339)"
        strokeWidth={2}
      >
        <path
          d="M4429.93 5217.092h22.033l9.455 15.364 9.37-15.364h22.455l-20.006 30.306 19.163 28.787h-22.033l-8.611-14.1-8.526 14.1h-22.455l19.162-29.04z"
          fill="none"
          stroke="#231f20"
        />
      </g>
      <text
        style={{
          InkscapeFontSpecification: "Montserrat-Bold",
        }}
        transform="rotate(.231 22.846 11313.16)"
        x={681.514}
        y={821.049}
        fontWeight={700}
        fontSize={24}
        fontFamily="Montserrat"
        fill="#231f20"
        strokeWidth={1.333}
      >
        <tspan
          y={821.049}
          x="681.51416 696.17822 715.04199 731.21826 753.05811"
        >
          {"THEME"}
        </tspan>
      </text>
      <g fill="none" stroke="#000" strokeWidth={2.667}>
        <path d="M493.426 934.72l-4.515-12.272c-.323-.876-1.121-1.246-1.905-1.122l-7.736 1.518c-1.336-1.83-3.166-3.645-4.887-5.169l2.033-7.548c.17-.892-.245-1.57-.845-1.847l-11.99-5.54c-.798-.37-1.675-.047-1.953.552l-4.43 6.44c-2.276-.324-4.644-.448-7.196-.172l-3.856-6.874c-.415-.678-1.215-1.047-2.091-.724l-12.272 4.514c-.877.322-1.247 1.12-1.124 1.906l1.519 7.734a41.24 41.24 0 00-5.168 4.887l-7.55-2.033c-1.106-.755-1.782-.339-2.152.46l-5.542 11.99c-.368.8-.047 1.676.553 1.952l6.44 4.434c-.324 2.274-.448 4.642-.172 7.194l-6.876 3.856c-.676.415-1.045 1.215-.724 2.091l4.515 12.272c.322.876 1.122 1.247 1.906 1.124l7.735-1.519c1.537 1.923 3.165 3.647 4.795 5.37l-2.034 7.548c-.17.892.246 1.57.844 1.845l11.99 5.541c.8.37 1.677.047 1.954-.552l4.432-6.44c2.475.415 4.843.54 7.103.372l3.856 6.875c.415.676 1.213 1.045 2.09.723l12.273-4.515c.876-.321 1.246-1.12 1.122-1.904l-1.517-7.736c1.923-1.536 3.845-3.073 5.368-4.795l7.55 2.035c.89.17 1.567-.247 1.845-.845l5.54-11.99c.37-.8.048-1.677-.552-1.954l-6.44-4.43c.324-2.276.448-4.645.173-7.197l6.875-3.856c1.06-.721 1.23-1.613 1.016-2.199" />
        <path d="M437.917 936.231c-3.601 7.794-.161 17.143 7.632 20.744 7.794 3.604 17.144.163 20.746-7.629 3.602-7.795.162-17.145-7.631-20.747-7.793-3.601-17.144-.162-20.747 7.632M533.442 884.34l-3.2 4.826c-1.584-.248-3.46-.386-5.228-.233l-2.918-5.23c-.415-.677-1.215-1.046-2.09-.723l-9.644 3.546c-.876.323-1.246 1.122-1.122 1.907l1.165 5.873c-1.447 1.031-2.692 2.151-3.83 3.566l-5.566-1.602c-.892-.169-1.568.244-1.845.846l-4.248 9.192c-.37.798-.048 1.676.552 1.952l4.826 3.201c-.246 1.584-.386 3.459-.233 5.227l-5.23 2.92c-.675.414-1.046 1.213-.723 2.09l3.548 9.642c.321.877 1.121 1.246 1.905 1.124l5.875-1.166c1.03 1.446 2.15 2.692 3.565 3.83l-1.603 5.565c-.169.892.246 1.57.846 1.847l9.192 4.246c.8.371 1.676.048 1.953-.552l3.2-4.826c1.784.34 3.46.386 5.228.234l2.919 5.23c.414.676 1.214 1.045 2.09.722l9.643-3.546c.876-.322 1.247-1.122 1.123-1.907l-1.166-5.873c1.447-1.03 2.692-2.15 3.831-3.566l5.565 1.602c.892.17 1.57-.244 1.846-.846l4.25-9.19c.367-.8.046-1.678-.554-1.954l-4.827-3.2c.247-1.585.387-3.46.233-5.228l5.23-2.92c.676-.413 1.046-1.213.724-2.09l-3.548-9.643c-.322-.876-1.122-1.245-1.906-1.123l-5.874 1.167c-1.03-1.447-2.15-2.693-3.564-3.83l1.601-5.566c.17-.892-.245-1.57-.845-1.847l-9.192-4.248c-.8-.369-1.676-.047-1.954.554" />
        <path d="M514.933 910.224c-2.863 6.193-.068 13.79 6.126 16.654 6.195 2.862 13.792.068 16.655-6.128 2.864-6.193.068-13.792-6.127-16.654-6.194-2.863-13.7-.268-16.654 6.128M485.547 851.535l-2.537 3.919c-1.384-.155-2.568-.216-3.845-.08l-2.288-3.967c-.415-.678-1.215-1.046-2.091-.724l-7.89 2.902c-.875.323-1.246 1.122-1.123 1.906l.829 4.505c-1.063.723-2.016 1.737-2.877 2.55l-4.474-1.34c-.308-.383-1.184-.06-1.553.738l-3.51 7.595c-.369.798-.048 1.676.553 1.952l3.918 2.54c-.153 1.384-.216 2.566-.079 3.842l-3.968 2.29c-.676.416-1.045 1.214-.722 2.092l2.901 7.889c.323.876 1.121 1.245 1.907 1.123l4.505-.828c.723 1.06 1.736 2.014 2.55 2.877l-1.34 4.473c-.169.892.246 1.568.846 1.846l7.593 3.509c.8.37 1.676.047 1.954-.552l2.538-3.92c1.384.153 2.568.216 3.844.079l2.29 3.968c.414.677 1.213 1.045 2.09.724l7.89-2.903c.876-.322 1.245-1.121 1.122-1.905l-.828-4.505c1.062-.723 2.016-1.738 2.878-2.551l4.473 1.34c.89.17 1.568-.247 1.845-.845l3.51-7.594c.37-.8.047-1.676-.552-1.953l-3.92-2.54c.154-1.384.216-2.567.079-3.843l3.968-2.29c.677-.415 1.046-1.214.724-2.091l-2.903-7.89c-.321-.875-1.121-1.245-1.905-1.12l-4.506.827c-.722-1.062-1.736-2.016-2.55-2.877l1.34-4.473c.169-.892-.246-1.57-.846-1.847l-7.593-3.51c-.8-.369-1.676-.046-2.247.662" />
        <path d="M470.731 872.576c-2.401 5.195-.236 11.53 5.159 14.025 5.396 2.495 11.532.236 14.025-5.16 2.494-5.394.236-11.53-5.158-14.024-5.396-2.493-11.624-.037-14.026 5.16" />
      </g>
      <g
        style={{
          InkscapeFontSpecification: "Montserrat-Bold",
        }}
        aria-label="COMP\xC9TENCE"
        fontWeight={700}
        fontSize={18}
        fontFamily="Montserrat"
        fill="#231f20"
      >
        <path d="M402.979 806.72q1.872.007 3.669.783 1.82.775 3.087 2.076l-2.483 2.918q-.812-1.011-1.962-1.592-1.126-.604-2.254-.609-1.991-.008-3.341 1.403-1.35 1.386-1.358 3.45-.009 2.112 1.33 3.534 1.338 1.42 3.33 1.429 1.056.004 2.186-.52 1.154-.523 2.046-1.431l2.485 2.65q-1.374 1.387-3.249 2.219-1.851.832-3.7.825-3.791-.015-6.301-2.497-2.51-2.483-2.495-6.179.014-3.623 2.592-6.037 2.578-2.438 6.418-2.422zM419.395 806.786q3.912.016 6.494 2.474 2.582 2.435 2.567 6.083-.015 3.672-2.64 6.133-2.603 2.462-6.49 2.446-3.888-.016-6.47-2.474-2.582-2.483-2.568-6.179.015-3.672 2.617-6.085 2.602-2.414 6.49-2.398zm.033 3.576q-1.968-.008-3.365 1.427-1.398 1.41-1.407 3.522-.008 2.112 1.378 3.582 1.41 1.445 3.354 1.453 1.944.008 3.294-1.427 1.374-1.458 1.382-3.57.009-2.112-1.354-3.533-1.338-1.446-3.282-1.454zM449.134 823.85l-3.768-.015.02-10.92-4.07 9.224-2.783-.012-3.995-9.256-.044 10.92-3.816-.015.068-16.824 4.68.019 4.52 10.026 4.6-9.99 4.656.02zM452.586 807.064l7.32.03q3.216.013 4.985 1.556 1.77 1.52 1.759 4.327-.012 2.952-1.795 4.577-1.782 1.625-4.998 1.612l-3.048-.013-.02 4.728-4.271-.017zm4.258 3.377l-.021 5.352 2.832.012q1.416.006 2.186-.687.771-.693.776-2.013.006-1.296-.76-1.971-.765-.675-2.18-.681zM479.77 802.998l-3.13 2.7-3.169-.013 2.56-4.022zm2.274 7.545l-8.88-.036-.013 3.336 8.015.033-.013 3.36-8.016-.033-.014 3.384 9.144.037-.013 3.36-13.416-.054.068-16.8 13.151.053zM497.907 810.68l-5.064-.021-.054 13.368-4.271-.018.054-13.367-5.016-.02.014-3.457 14.351.058zM512.884 810.668l-8.88-.036-.014 3.336 8.016.032-.013 3.36-8.016-.032-.014 3.384 9.144.037-.014 3.36-13.416-.055.068-16.8 13.152.054zM531.357 824.182l-3.768-.015-7.686-10.375-.042 10.344-4.008-.016.068-16.8 3.768.015 7.71 10.4.042-10.368 3.984.016zM542.657 807.284q1.872.008 3.67.783 1.82.775 3.087 2.076l-2.484 2.918q-.812-1.011-1.962-1.592-1.125-.604-2.253-.609-1.992-.008-3.342 1.403-1.35 1.386-1.358 3.45-.008 2.112 1.33 3.534 1.338 1.421 3.33 1.43 1.056.003 2.186-.52 1.155-.523 2.046-1.432l2.485 2.65q-1.373 1.387-3.248 2.22-1.852.832-3.7.824-3.792-.015-6.302-2.497-2.51-2.482-2.495-6.178.015-3.624 2.593-6.038 2.577-2.438 6.417-2.422zM564.531 810.876l-8.88-.036-.013 3.336 8.015.033-.013 3.36-8.016-.033-.014 3.384 9.144.037-.013 3.36-13.416-.054.068-16.8 13.152.053z" />
      </g>
      <path
        d="M347.708 785.688c6.965-40.025-7.171-80.744-37.802-108.887l-36.488-33.528c-77.132-70.87-35.502-195.352 70.447-210.646 73.45-10.604 136.744-54.987 169.256-118.683l14.87-29.133c41.895-82.084 158.949-82.751 201.778-1.151l37.88 72.17c19.037 36.273 55.581 61.28 97.72 66.873l50.2 6.664c106.116 14.085 149.164 138.084 72.844 209.83l-36.104 33.942c-30.307 28.489-43.977 69.366-36.556 109.31"
        fill="#31838e"
      />
      <path
        d="M568.707 84.544l-17.096 14.461c-.574.484-.636 1.18-.166 1.81l3.638 4.886c.315.421 1.175.496 1.586.15l18.642-15.715m27.726-23.429l30.228-25.367-5.46-6.563-28.433 23.305M680.522 110.838c-3.486 4.092-9.304 7.262-9.304 7.262s.104 3.452 2.528 5.158c2.425 1.705 5.33.202 5.33.202s.675 2.828 3.274 3.942c2.598 1.113 8.082-2.343 10.666-3.683 2.586-1.339 5.363-3.985 6.824-6.075 1.46-2.088-.372-4.168-1.758-5.361-1.387-1.193-.017-3.212 0-5.547.017-2.336-2.38-3.94-3.77-4.557-1.39-.617-3.27-2.213-2.893-3.803.377-1.586.063-3.198-1.035-4.677-1.098-1.48-3.917-1.896-5.285-2.105-1.368-.208-1.817-2.731-2.227-3.862-.408-1.13-1.681-2.486-5.136-1.994-3.453.492-6.942 4.485-6.942 4.485-5.067 9.044-5.46 7.587-7.831 10.445-2.373 2.859-1.048 4.124 2.947 8.83 3.994 4.705 1.94 8.022-.163 9.438-2.101 1.419-8.412-2.354-10.54-7.73-2.02-5.098-1.532-9.478 2.835-13.071 4.368-3.595 7.868-4.29 7.868-4.29M675.949 102.252s-4.852 5.545-10.042 7.246"
        fill="none"
        stroke="#122c2f"
        strokeWidth={2.667}
        strokeMiterlimit={10}
      />
      <g
        clipPath="url(#cp3_svg__b)"
        transform="matrix(1.33333 0 0 -1.33333 -5200.984 4645.427)"
      >
        <path
          d="M4432.669 3368.831l-7.442 6.126-38.29 58.556c-.277.423 4.488 4.468 4.825 3.954l38.755-59.202 2.619-9.142z"
          fill="#122c2f"
          fillRule="evenodd"
        />
      </g>
      <path
        d="M684.716 118.04s-4.406 3.153-5.814 5.98M671.218 118.1s-.475.96-3.988-.589M640.893 24.937l4.19 5.87c.47.66.456 1.487-.032 1.835l-2.801 1.908c-.49.35-1.275.095-1.745-.567l-4.191-5.87c-.47-.66-.456-1.486.032-1.835l2.801-1.907c.49-.35 1.274-.095 1.746.566z"
        fill="none"
        stroke="#122c2f"
        strokeWidth={2.667}
        strokeMiterlimit={10}
      />
      <path
        d="M610.944 27.467c-2.15-4.642 11.524-15.044 15.832-11.492 9.652 7.96 17.595 19.358 23.544 32.436 1.96 4.306-11.621 15.005-15.832 11.492-10.36-8.643-17.824-20.091-23.544-32.436"
        fill="#122c2f"
        fillRule="evenodd"
      />
      <path
        d="M607.236 64.413s3.553 1.984 5.542 5.473c1.99 3.49 2.036 6.35-1.058 11.234-3.094 4.884-9.687 7.816-11.559 6.105-1.872-1.71-3.419-5.29 1.221-9.361 4.64-4.07 6.136-5.128 4.208-8.303-1.929-3.176-2.53-1.79-6.218-11.479 0 0-2.867-4.46-6.212-5.453-3.344-.992-4.803.163-5.372 1.222-.571 1.057-1.384 3.487-2.768 3.493-1.384.01-4.234.01-5.535 1.31-1.304 1.3-1.85 2.85-1.71 4.476.14 1.627-1.954 2.93-3.42 3.338-1.465.406-4.07 1.642-4.395 3.956-.326 2.312.733 4.51-.814 5.486-1.548.976-3.662 2.768-2.524 5.047 1.14 2.28 3.5 5.305 5.862 7.008 2.361 1.703 7.28 5.924 10.012 5.203 2.733-.722 3.816-3.419 3.816-3.419s2.653 1.912 5.301.58c2.65-1.333 3.257-4.73 3.257-4.73s-5.292-3.991-8.141-8.549M581.525 83.563s3.898 3.763 4.876 6.765M592.51 69.227s3.987 6.195 8.872 8.637M594.87 85.598s.33 1.017 4.03 0"
        fill="none"
        stroke="#122c2f"
        strokeWidth={2.667}
        strokeMiterlimit={10}
      />
      <g>
        <path
          d="M304.792 403.905a316.027 316.027 0 01-.604-22.139c.029-3.566.104-7.137.274-10.7.155-3.213.444-6.462 1.567-9.502 2.155-5.835 7.767-8.888 13.112-11.326 5.913-2.693 11.913-5.2 17.873-7.788 12.215-5.302 24.398-10.776 35.888-17.541a153.142 153.142 0 0029.974-23.048c18.218-17.999 32.153-39.723 45.394-61.487 13.855-22.772 27.228-46.258 45.087-66.214 8.436-9.427 17.812-18.08 27.988-25.604 5.316-3.932 10.884-7.606 16.699-10.818M727.624 143.568c11.221 7.002 21.636 15.32 31.065 24.592 19.783 19.456 34.223 43.596 48.797 66.988 6.712 10.773 13.548 21.469 20.286 32.228 6.597 10.536 13.322 21.022 20.881 30.902 7.083 9.26 14.896 18.107 24.252 25.136 10.663 8.01 23.239 11.892 36.05 14.936 6.5 1.544 13.033 2.978 19.435 4.903 6.291 1.892 12.807 4.137 18.426 7.605 2.602 1.606 4.938 3.663 6.406 6.383 1.655 3.064 2.146 6.616 2.398 10.043.556 7.546.63 15.158.522 22.722a322.191 322.191 0 01-.36 11.235"
          fill="none"
          stroke="#000"
          strokeWidth={2.66666}
        />
        <path
          d="M847.37 1066.301l-28.452 44.224c-9.606 14.931-33.384 27.299-53.006 27.568l-243.924 3.356c-19.62.27-43.729-11.438-53.741-26.1l-29.356-42.981"
          fill="none"
          stroke="#122c2f"
          strokeWidth={2.66666}
        />
      </g>
      <g opacity={0.2}>
        <path
          d="M746.78 1052.623l-50.712-27.317c-42.566-22.934-93.262-22.644-135.566.772l-50.395 27.894c-106.53 58.966-231.967-34.578-212.261-158.297l9.321-58.525c7.824-49.13-8.128-99.122-42.657-133.687l-41.134-41.176c-86.953-87.043-40.116-239.825 79.258-258.54h0c82.757-12.975 154.05-67.419 190.647-145.59v-.002c52.791-112.76 207.172-113.641 261.246-1.49l25.58 53.056c21.472 44.536 62.662 75.254 110.148 82.145l56.568 8.208c119.58 17.352 168.156 169.59 82.201 257.62l-40.663 41.643c-34.133 34.956-49.513 85.126-41.129 134.162l9.99 58.418c21.113 123.485-103.247 218.454-210.443 160.706z"
          fill="none"
          stroke="#6bced0"
          strokeWidth={36}
          strokeMiterlimit={10}
        />
      </g>
      <g>
        <path
          d="M745.64 1053.58l-50.221-27.381c-42.157-22.986-92.363-22.7-134.256.765l-49.907 27.952c-105.496 59.088-229.724-34.67-210.218-158.659l9.228-58.653c7.745-49.236-8.056-99.339-42.254-133.981l-40.738-41.27c-86.119-87.24-39.744-240.354 78.473-259.1h0c81.955-12.998 152.556-67.557 188.793-145.898 52.272-113.006 205.16-113.878 258.719-1.475l25.336 53.172c21.267 44.635 62.061 75.423 109.088 82.332l56.021 8.23c118.426 17.398 166.542 169.975 81.424 258.19l-40.266 41.73c-33.8 35.031-49.028 85.311-40.723 134.457l9.896 58.544c20.919 123.757-102.232 218.925-208.396 161.045z"
          fill="none"
          stroke="#31838e"
          strokeWidth={16}
          strokeMiterlimit={10}
        />
      </g>
      <g>
        <path
          d="M538.155 620.516h69.6l29.867-48.533 29.6 48.533h70.933l-63.2-95.733 60.533-90.934h-69.6l-27.2 44.534-26.933-44.534h-70.933l60.533 91.734z"
          aria-label="X"
          fontSize={200}
          fontFamily="Gotham Ultra"
          fill="#fff"
        />
      </g>
      <g fontSize={40} fontFamily="Gotham Ultra" fill="#fff">
        <path
          d="M390.761 736.686h12.48v-26.774h10.987v-10.56h-34.453v10.56h10.986zM419.828 736.686h12.48v-37.334h-12.48zM448.895 736.686h12.48v-26.774h10.986v-10.56h-34.453v10.56h10.987zM477.855 736.686h12.48v-10.667H493l7.04 10.667h14.24l-8.693-12.694c4.533-2.186 7.36-5.973 7.36-11.413v-.107c0-3.84-1.173-6.613-3.413-8.853-2.614-2.613-6.827-4.267-13.44-4.267h-18.24zm12.48-19.574v-7.306h5.44c2.88 0 4.746 1.173 4.746 3.573v.107c0 2.293-1.813 3.626-4.8 3.626zM518.655 736.686h32.106v-10.24h-19.84v-4.054h18.24v-9.013h-18.24v-3.787h19.574v-10.24h-31.84zM573.001 736.686h13.867c15.093 0 22.667-7.84 22.667-18.88v-.107c0-11.04-7.414-18.347-22.24-18.347H573zm12.48-10.88v-15.574h2.08c5.707 0 9.387 2.347 9.387 7.734v.106c0 5.387-3.68 7.734-9.387 7.734zM633.641 737.432c11.147 0 18.56-5.013 18.56-17.76v-20.32h-12.693v20.694c0 4.533-2.4 6.346-5.76 6.346s-5.76-1.973-5.76-6.613v-20.427h-12.693v20.587c0 12.373 7.2 17.493 18.346 17.493zM675.028 736.686h20.693c9.44 0 14.347-4.374 14.347-10.347v-.107c0-5.12-3.093-7.68-7.893-9.066 4-1.387 6.666-4.107 6.666-8.534v-.106c0-2.56-.96-4.48-2.293-5.814-2.187-2.186-5.44-3.36-10.613-3.36h-20.907zm12.16-22.667v-5.227h5.387c2.666 0 4 .907 4 2.56v.107c0 1.653-1.28 2.56-3.947 2.56zm0 13.227v-5.547h6.293c2.72 0 4.054 1.12 4.054 2.72v.107c0 1.6-1.387 2.72-4.107 2.72zM712.735 736.686h13.333l1.92-5.014h13.067l1.973 5.014h13.547l-15.734-37.6h-12.373zm18.4-13.867l3.413-9.067 3.413 9.067zM760.788 736.686h13.867c15.093 0 22.666-7.84 22.666-18.88v-.107c0-11.04-7.413-18.347-22.24-18.347h-14.293zm12.48-10.88v-15.574h2.08c5.707 0 9.387 2.347 9.387 7.734v.106c0 5.387-3.68 7.734-9.387 7.734zM823.508 737.486c6.773 0 12.427-2.294 16.48-5.6v-17.28h-18.08v8h6.4v3.733c-.96.533-2.133.853-4.267.853-5.226 0-8.906-3.626-8.906-8.906v-.107c0-5.067 3.52-8.8 8.373-8.8 3.093 0 5.813 1.173 8.267 3.253l6.986-8.426c-4.053-3.52-9.226-5.654-15.626-5.654-11.787 0-20.587 8.32-20.587 19.467v.107c0 11.573 9.333 19.36 20.96 19.36zM846.281 736.686h32.107v-10.24h-19.84v-4.054h18.24v-9.013h-18.24v-3.787h19.573v-10.24h-31.84z"
          style={{
            InkscapeFontSpecification: "Gotham-Ultra",
          }}
        />
      </g>
    </svg>
  );
}

export default SvgCp3;
